import { connect } from 'react-redux'
import MainPage from './main-page'
import { config } from '../../../redux/selectors'
import { withRouter } from 'react-router-dom'

const mapState = (state, ownProps) => {
  return {
    config: config(state),
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default withRouter(connect(mapState, mapDispatch)(MainPage))



// WEBPACK FOOTER //
// ./src/components/views/main-page/main-page.connect.js